"use client"
import { useCallback, useSyncExternalStore } from "react"

const eventName="danaro-company-selection"
export function useCompanySelection(viewer?:string) {
  const key=viewer?`danaro:my:company:${viewer}`:null
  const read=useCallback(()=>{if(!key||typeof window==="undefined")return null;try{const value=localStorage.getItem(key);return value&&/^[0-9a-f-]{36}$/i.test(value)?value:null}catch{return null}},[key])
  const subscribe=useCallback((listener:()=>void)=>{if(!key)return()=>{};window.addEventListener(eventName,listener);window.addEventListener("storage",listener);return()=>{window.removeEventListener(eventName,listener);window.removeEventListener("storage",listener)}},[key])
  const selected=useSyncExternalStore(subscribe,read,()=>null)
  const select=useCallback((value:string|null)=>{if(!key||read()===value)return;try{if(value)localStorage.setItem(key,value);else localStorage.removeItem(key);window.dispatchEvent(new Event(eventName))}catch{}},[key,read])
  return [selected,select] as const
}
